import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './face.svg'
import _imports_1 from './tw.svg'
import _imports_2 from './ln.svg'
import _imports_3 from './link.svg'


const _withScopeId = n => (_pushScopeId("data-v-71eeb7e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "share" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "arrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.inface(0))),
      onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.leaveface && _ctx.leaveface(...args))),
      href: `https://www.facebook.com/sharer/sharer.php?u=${_ctx.url}`
    }, _hoisted_4, 40, _hoisted_2),
    _createElementVNode("a", {
      onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.inface(1))),
      onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.leaveface && _ctx.leaveface(...args))),
      href: `http://www.twitter.com/share?url=${_ctx.url}`
    }, _hoisted_7, 40, _hoisted_5),
    _createElementVNode("a", {
      onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.inface(2))),
      onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.leaveface && _ctx.leaveface(...args))),
      href: `https://www.linkedin.com/shareArticle?mini=true&url=${_ctx.url}&title=&summary=&source=`
    }, _hoisted_10, 40, _hoisted_8),
    _createElementVNode("img", {
      onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.inface(3))),
      onMouseleave: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.leaveface && _ctx.leaveface(...args))),
      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cpyurl && _ctx.cpyurl(...args))),
      src: _imports_3
    }, null, 32),
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.popstype),
      class: "pop"
    }, [
      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.popstype.text), 1)
    ], 4)
  ]))
}